import { styled } from '@mui/material/styles';
import { Accordion, AccordionSummary, Box, Typography, LinearProgress } from '@mui/material';

export const StyledAccordion = styled(Accordion)({
  overflowX: 'hidden',
  boxSizing: 'border-box'
});

export const StyledAccordionSummary = styled(AccordionSummary)({
  flexDirection: 'row-reverse'
});

export const LessonNameBox = styled(Box)({
  width: '30%'
});

export const UnderlinedTypography = styled(Typography)({
  textDecoration: 'underline'
});

export const PercentageBox = styled(Box)({
  width: '10%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'right'
});

export const StyledLinearProgress = styled(LinearProgress)({
  width: '60%',
  height: '40%',
  maxHeight: '9px'
});

export const PointsBox = styled(Box)({
  width: '15%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'right'
}); 